import SimpleBar from "simplebar-react";
import { styled } from "@mui/material/styles";

const Scrollbar = styled(SimpleBar)``;

export default Scrollbar;
